export const en = {
  "Transaction Date": "Issue Date",
  "Tetapan app": "App setting",
  "Tetapan notifikasi": "Notification setting",
  "Search partner by name, email or phone number": "Search customer",
};
